export var contentCls = [
    'inline-flex',
    'items-center',
    'mt-px-16',
    'pt-px-9',
    'pb-px-9',
    'pl-px-18',
    'leading-normal',
    'font-medium',
    'text-gray-700',
    'bg-white',
    'shadow',
];
